import { matchDesktop, isDesktop } from './media-query';

/**
 * Navigation handler
 * 1. Controls mega menu active state and show mega menu items in slide
 * 2. Controls relation and logic between top section and navbar
 *  a) When user clicks on top section drop down hide mega menu
 *  b) When user clicks on main nav links hide top drop down items
 */
export default class Navigation {
  mainLink = $('.js-main-link');
  topToggle = $('.top .js-top-toggle');
  mainLinkMobile = $('.js-main-link-mobile');

  megaMenuOpened = new Event('megaMenuOpened');
  topDropDownOpened = new Event('topDropDownOpened');

  constructor() {
    const matchDesktopdevice = matchDesktop();
    this.megaMenuLogic(isDesktop());

    if (this.mainLink.length) {
      try {
        // Chrome & Firefox
        matchDesktopdevice.addEventListener('change', (media) => this.megaMenuLogic(media.matches));
      } catch (e1) {
        try {
          // Safari
          matchDesktopdevice.addListener((media) => this.megaMenuLogic(media.matches));
        } catch (e2) {
          console.error(e2);
        }
      }
    }

    if (this.topToggle.length) {
      $(this.topToggle).on('click', this.topDropdownHandler.bind(this));
      $(this.topToggle).on('topDropDownOpened', this.closeMegaMenu.bind(this));
    }

    $(window).on('scroll', this.initFixedNav.bind(this));
  }

  megaMenuHandler(element: Event) {
    const trigger = (element.currentTarget) as HTMLElement;
    const triggerId = this.getToggleId(trigger);
    this.removeActiveClassMainLinks(triggerId);
    const id = trigger.getAttribute('data-mega-menu');
    if(isDesktop()) {
      $('.slide-menu').removeClass('opened');
    }
    $(`.slide-menu#${id}`).addClass('opened');
    element.currentTarget.dispatchEvent(this.megaMenuOpened);
  }

  /**
   * Close all dropdown from top component except clicked one
   * @param element clikced js-toggle element
   */
  topDropdownHandler(element: Event) {
    const htmlElement = (element.currentTarget) as HTMLElement;
    const triggerWrapperId = htmlElement
      .closest('.js-toggle-wrap')
      .getAttribute('data-toggleId');
    if (triggerWrapperId) {
      $(this.topToggle).each(index => {
        const button = $(this.topToggle[index]);
        const topToggleWrapper = button.closest('.js-toggle-wrap');
        const topToggleId = topToggleWrapper.attr('data-toggleId');
        if (topToggleId !== triggerWrapperId) {
          topToggleWrapper.removeClass('active');
          $(`#${topToggleId}`).removeClass('opened');
        }
      });
      element.currentTarget.dispatchEvent(this.topDropDownOpened);
    }
  }

  /**
   * Initialize functions for the fixed navigation.
   */
  initFixedNav() {
    let $body = $('body');

    let $navigation = $('.js-navbar');
    let scrollTop = $(window).scrollTop();

    if (scrollTop > 36) {
      $navigation.addClass('is-fixed');
      $body.addClass('js-nav-fixed nav-fixed');
    } else {
      $navigation.removeClass('is-fixed');
      $body.removeClass('js-nav-fixed nav-fixed');
    }
  }

  closeTopDropdown() {
    $('.top .js-toggle-wrap').each((index, element) => {
      const id = element.getAttribute('data-toggleId');
      $(`#${id}`).removeClass('opened');
      element.classList.remove('active');
    });
  }

  closeMegaMenu() {
    $('#mega-menu .js-toggle-wrap').each((index, element) =>
      element.classList.remove('active')
    );
    $('#mega-menu .slide-menu').each((index, element) =>
      element.classList.remove('opened')
    );
  }

  getToggleId(button: HTMLElement) {
    return $(button)
      .closest('.js-toggle-wrap')
      .attr('data-toggleId');
  }

  removeActiveClassMainLinks(triggerId: string) {
    $('#navbar-main-links .js-toggle-wrap').each((index, element) => {
      const elementToggleId = this.getToggleId(element);
      if (triggerId !== elementToggleId) {
        element.classList.remove('active');
      }
    });
  }

  /**
   * Open dropdown and close other opened dropdowns/main link/mega-menu from main buttons
   * @param element main button icon on mobile device
   */
  mainLinkMobileHandler(element: Event) {
    const triggerId = this.getToggleId(element.currentTarget as HTMLElement);
    $(this.mainLinkMobile).each((index, element) => {
      const toggleWrap = $(element).closest('.js-toggle-wrap');
      const id = toggleWrap.attr('data-toggleId');

      // click on language and search
      if (triggerId !== id && triggerId !== 'navbar-main-links') {
        toggleWrap.removeClass('active');
        $(`#${id}`).removeClass('opened');
        this.closeMegaMenu();

        return;
      }

      // click on hamburger button only
      if (triggerId === 'navbar-main-links' && id !== 'navbar-main-links') {
        toggleWrap.removeClass('active');
        $(`#${id}`).removeClass('opened');
      }
    });
  }

  megaMenuLogic(isDesktop: boolean) {
    if(isDesktop) {
      this.mainLinkMobile.off('click', this.mainLinkMobileHandler.bind(this));
      this.mainLink.on('click', this.megaMenuHandler.bind(this));
      $(this.mainLink).on('megaMenuOpened', this.closeTopDropdown.bind(this));
    } else {
      this.mainLink.off('click', this.megaMenuHandler.bind(this));
      $(this.mainLinkMobile).on('click', this.mainLinkMobileHandler.bind(this));
    }
  }
}
